import { useState, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useLocale } from "@/i18n/LocaleContext";
import logoEqualitas from "@/assets/logo-equalitas.jpg";

const MAINTENANCE_MODE = false;
const LS_KEY = "equalitas_access";

async function sha256(message: string): Promise<string> {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("");
}

const EXPECTED_HASH = "9ff11b6bd94899bdec0ed692db830971fcc9d93d84336c9529b75a0e361fcef4";

const MaintenanceGate = ({ children }: { children: ReactNode }) => {
  const location = useLocation();
  const { t } = useLocale();
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);
  const [authenticated, setAuthenticated] = useState(
    () => localStorage.getItem(LS_KEY) === "granted"
  );

  if (!MAINTENANCE_MODE) return <>{children}</>;
  if (location.pathname.startsWith("/admin")) return <>{children}</>;
  if (authenticated) return <>{children}</>;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const hash = await sha256(input);
    if (hash === EXPECTED_HASH) {
      localStorage.setItem(LS_KEY, "granted");
      setAuthenticated(true);
    } else {
      setError(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="w-full max-w-md text-center space-y-8">
        <img
          src={logoEqualitas}
          alt="Logotipo de Equalitas Abogados Asociados - Especialistas en extranjería en Madrid"
          className="h-20 mx-auto object-contain"
          width={200}
          height={80}
        />
        <h1 className="text-2xl md:text-3xl font-bold text-foreground">
          {t("maintenance.heading")}
        </h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="password"
            placeholder={t("maintenance.placeholder")}
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              setError(false);
            }}
            className={error ? "border-destructive" : ""}
          />
          {error && (
            <p className="text-sm text-destructive">{t("maintenance.error")}</p>
          )}
          <Button type="submit" className="w-full">
            {t("maintenance.submit")}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default MaintenanceGate;
